var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.536 21c0 .844.68 1.5 1.553 1.5h9.322c.841 0 1.553-.656 1.553-1.5V10.5H7.536V21zm8.803-8c0-.25.227-.5.518-.5.26 0 .518.25.518.5v7c0 .281-.259.5-.518.5a.503.503 0 0 1-.518-.5v-7zm-3.107 0c0-.25.227-.5.518-.5.259 0 .518.25.518.5v7c0 .281-.26.5-.518.5a.503.503 0 0 1-.518-.5v-7zm-3.107 0c0-.25.227-.5.518-.5.259 0 .518.25.518.5v7c0 .281-.26.5-.518.5a.503.503 0 0 1-.518-.5v-7zm10.357-5.5h-3.884l-.323-.563c-.13-.25-.389-.437-.68-.437h-3.722c-.291 0-.55.188-.68.438l-.291.562H7.018A.523.523 0 0 0 6.5 8v1c0 .281.227.5.518.5h13.464c.26 0 .518-.219.518-.5V8c0-.25-.259-.5-.518-.5z",
    fill: "#1E2B3B",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashAlt);
export default __webpack_public_path__ + "static/media/trash-alt.874e9a9fdbd2b5ccfc0b9e35729d1a7e.svg";
export { ForwardRef as ReactComponent };